import { render } from "./ProductInline.vue?vue&type=template&id=b2838730&scoped=true"
import script from "./ProductInline.vue?vue&type=script&lang=js"
export * from "./ProductInline.vue?vue&type=script&lang=js"

import "./ProductInline.vue?vue&type=style&index=0&id=b2838730&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2838730"],['__file',"src/components/ProductInline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2838730"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2838730', __exports__)) {
    console.log('reload')
    api.reload('b2838730', __exports__)
  }
  
  module.hot.accept("./ProductInline.vue?vue&type=template&id=b2838730&scoped=true", () => {
    console.log('re-render')
    api.rerender('b2838730', render)
  })

}


export default __exports__